export default [
  {
    header: 'Produzioni',
    resource: 'produzioni',
    action: 'read',
  },
  {
    title: 'Spettacoli',
    route: 'spettacoli',
    resource: 'spettacoli',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Scritture',
    route: 'scritture',
    resource: 'scritture',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Altre Scritture',
    route: 'altrescritture',
    resource: 'scritture',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Ricevute',
    route: 'ricevute',
    resource: 'scritture',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Cedolini',
    route: 'cedolini',
    resource: 'scritture',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Allestimenti',
    route: 'allestimenti-produzioni',
    resource: 'scritture',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Altre Spese',
    route: 'altrespese',
    resource: 'scritture',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Costo Produzioni',
    route: 'costo-produzioni',
    resource: 'costi',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Bilancio Produzioni',
    icon: 'TrelloIcon',
    route: 'bilancio-produzioni',
    resource: 'costi',
    action: 'read',
  },
  {
    title: 'Bilancio Coccia',
    route: 'bilancio-coccia',
    resource: 'personale-produzioni',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Importa Bilancio Preventivo',
    route: 'importa-bilancio-preventivo-coccia',
    resource: 'personale-produzioni',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Importa Bilancio Consuntivo',
    route: 'importa-bilancio-coccia',
    resource: 'personale-produzioni',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Verifica Bilancio Coccia',
    route: 'verifica-bilancio-coccia',
    resource: 'personale-produzioni',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Bilancio Ministero',
    route: 'bilancio-ministero',
    resource: 'personale-produzioni',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Punteggi Ministero',
    route: 'punteggi-ministero',
    resource: 'personale-produzioni',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Excel ministero',
    route: 'excel-ministero',
    resource: 'scritture',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Oneri Consuntivi Personale',
    route: 'quote-oneri-personale',
    resource: 'scritture',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Mostra Oneri Personale',
    route: 'mostra-oneri-personale',
    resource: 'scritture',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Pratiche VVF',
    route: 'pratiche-vvf',
    resource: 'spettacoli',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Pratiche SIAE',
    route: 'pratiche-siae',
    resource: 'spettacoli',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Protocollo',
    route: 'protocollo',
    resource: 'spettacoli',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Modello C',
    route: 'modelloC',
    resource: 'spettacoli',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Allegati D E',
    route: 'allegatiDE',
    resource: 'spettacoli',
    action: 'read',
    icon: 'TrelloIcon',
  },  
  // {
  //   title: 'Personale Ministero',
  //   route: 'personale-ministero-produzioni',
  //   resource: 'personale-produzioni',
  //   action: 'read',
  //   icon: 'TrelloIcon',
  // },
  // {
  //   title: 'Calendario Ministero',
  //   route: 'calendario-ministero-produzioni',
  //   resource: 'calendario-produzioni',
  //   action: 'read',
  //   icon: 'TrelloIcon',
  // },
]
